import { useQuery } from 'react-query'
import { request } from '../api/apiCore'

const fetchCategoryById = (id, root) => request({ url: `${root}/${id}.json` })
export const useCategoryData = (id, root) => useQuery(['category', id], () => fetchCategoryById(id, root))
